import type { IconSvgObject } from './types';

const MedalFirstPlaceIcon: IconSvgObject = [
  ["circle", { cx: "12", cy: "15.5", r: "6.5", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M9 9.5L5.5 2", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M15 9.5L18.5 2", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M15 2L14 4.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M12.5 9L9.5 2", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }],
  ["path", { d: "M11 18H12M12 18H13M12 18V13L11 13.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "5" }]
];

export default MedalFirstPlaceIcon;
